// FullscreenOverlay.jsx
import React from "react";
import "./Overlay.css";

function FullscreenOverlay({ active, message }) {
    if (!active) return null;

    return (
        <div className="app-overlay">
            <div className="spinner"></div>
            <p style={{ color: "#fff", marginTop: "10px" }}>{message}</p>
        </div >
    );
}

export default FullscreenOverlay;
